export function deselectNode(box: HTMLDivElement) {
    box.style.width = '0px';
    box.style.height = '0px';
    box.style.left = '-15px';
    box.style.top = '-15px';
}
